import React from 'react';
import styled from 'styled-components';
import StarRating from './StarRating';

const Card = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
`;

const VersionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const VersionName = styled.h2`
  font-size: 1.5rem;
  margin: 0;
  color: #1d1d1f;
`;

const ScoreBadge = styled.span`
  background-color: ${props => {
    // 颜色根据分数变化（0-100分）
    if (props.score >= 90) return '#34c759'; // 优秀 - 绿色
    if (props.score >= 70) return '#5ac8fa'; // 良好 - 蓝色
    if (props.score >= 60) return '#ffcc00'; // 及格 - 黄色
    return '#ff3b30'; // 不及格 - 红色
  }};
  color: ${props => props.score >= 60 ? '#1d1d1f' : 'white'};
  border-radius: 12px;
  padding: 4px 10px;
  font-size: 1rem;
  font-weight: bold;
`;

const Stats = styled.div`
  margin: 15px 0;
  color: #86868b;
  font-size: 0.9rem;
`;

const RateButton = styled.button`
  background-color: #0071e3;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
  width: 100%;
  margin-top: 10px;
  
  &:hover {
    background-color: #0077ed;
  }
`;

function VersionCard({ version, averageScore, totalRatings, onRateClick }) {
  // 转换5分制到100分制
  const originalScore = parseFloat(averageScore);
  const score100 = Math.round(originalScore * 20);
  
  return (
    <Card>
      <VersionHeader>
        <VersionName>iOS {version}</VersionName>
        <ScoreBadge score={score100}>{score100}</ScoreBadge>
      </VersionHeader>
      <StarRating 
        rating={originalScore} 
        readOnly={true} 
      />
      <Stats>
        Score: {score100}/100
        <br />
        Rated by {totalRatings} people
      </Stats>
      <RateButton onClick={() => onRateClick(version)}>Rate This Version</RateButton>
    </Card>
  );
}

export default VersionCard; 
